module.exports = __webpack_public_path__ + "assets/img/fa64ce6a6b2c352a03374e1e6fe2f2ea.png";